/* eslint-disable no-restricted-globals */
/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types'
import {Redirect} from 'react-router'
import {NavLink,Route,Switch} from 'react-router-dom'
import {connect} from 'react-redux'
import classNames from 'classnames'
import _ from 'lodash'
import Drawer from '@material-ui/core/Drawer'
import IconButton from '@material-ui/core/IconButton'
import AccountCircle from '@material-ui/icons/AccountCircle';
import DesktopWindows from '@material-ui/icons/DesktopWindows'
import DnsIcon from '@material-ui/icons/Dns'
import AlarmIcon from '@material-ui/icons/Alarm'
import TextsmsIcon from '@material-ui/icons/Textsms'
import DashboardIcon from '@material-ui/icons/Dashboard'
import HomeIcon from '@material-ui/icons/Home'
import Divider from '@material-ui/core/Divider'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import SupervisorAccount from '@material-ui/icons/SupervisorAccount'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import MenuIcon from '@material-ui/icons/Menu'
import Menu from '@material-ui/core/Menu';
import Dialog from '@material-ui/core/Dialog'
import MenuItem from '@material-ui/core/MenuItem';
import Badge from '@material-ui/core/Badge'
import Collapse from '@material-ui/core/Collapse'
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloudDoneIcon from '@material-ui/icons/CloudDone'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import { withStyles } from '@material-ui/core/styles'
import Icenter from '../routes/icenter/components/list'
import User from '../routes/user/components/list'
import Permission from '../routes/permission/components/list'
import GlobalSet from '../routes/global/components/list'
import Notice from '../routes/notice/components/list'
import Modules from '../routes/modules/components/list'
import News from '../routes/news/components/list'
import {signOutFn} from '../../sign/reducers/user'
import {getUnReadTotal} from '../routes/news/reducers/list'
import {getAllSetting, modify as modifySetting} from '../routes/global/reducers/list'
import {getList} from '../routes/notice/reducers/list'
import QQ from '../../../uis/qq'
import Message from '../../../uis/tip/snackbars'
import Feedback from '../../../uis/feedback'
import UpdateDes from '../../../uis/updateDes'
import DateFormat from '../../../util/dateFormat'
import Ordersd from '../routes/order_sd/components/list';
import OrderDomain from '../routes/order_domain/components/list';
import OrderJzhz from '../routes/order_jzhz/components/list'; 
import OrderCopy from '../routes/order_copy/components/list';
import OrderMy from '../routes/order_my/components/list';
import Invoice from '../routes/invoice/components/list'; 
import SiteTemplate from '../routes/site_template/components/list';
import Baojiadan from '../routes/baojiadan/components/list';
import QuestionAnswer from '../routes/question_answer/components/list'; 
import Blacklist from '../routes/blacklist/components/list'; 
import TodoTask from '../routes/todo_task/components/list'; 
import Photogallery from '../routes/photo_gallery/components/list'; 
import OrderRenew from '../routes/order_renew/components/list'; 
// import new components


const drawerWidth = 180;
const styles = theme => ({
    root: {
      flexGrow: 1,
      zIndex: 1,
      overflow: 'hidden',
      position: 'relative',
      display: 'flex',
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginLeft: 12,
      marginRight: 36,
    },
    hide: {
      display: 'none',
    },
    drawerPaper: {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerPaperClose: {
      overflowX: 'hidden',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing.unit * 7,
      [theme.breakpoints.up('sm')]: {
        width: theme.spacing.unit * 9,
      },
    },
    toolbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0 8px',
      ...theme.mixins.toolbar,
    },
    toolPadding: {
        paddingLeft: 0
    },
    content: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.default,
      padding: theme.spacing.unit * 3,
    },
    navStyle: {
        textDecoration: 'none'
    },
    flex:{
        flex:1
    },
    noticeButton: {
        color: '#fff',
        fontSize: 14
    },
    margin: {
        margin: theme.spacing.unit * 2,
    },
    listItemText: {
        padding: '0 8px'
    },
    listItemIcon: {
        marginRight: 0
    },
    contentContainer: {
        paddingLeft: theme.spacing.unit * 3,
    },
    listIcon: {
        color: '#4051b5',
        marginRight: theme.spacing.unit
    },
    titleIcon: {
        marginRight: theme.spacing.unit
    },
    expandTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center'
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
        display: 'flex',
        alignItems: 'center',
    },
    nested: {
        paddingLeft: theme.spacing.unit * 4,
    },
  });
  
const menuActive = {backgroundColor: '#e4d2ec',display: 'inline-block',width: '100%'};

const menus = [
    {path: '/icenter',icon: <HomeIcon />,primaryText: '个人面板'},
    {path: '/todo-task',icon: <DashboardIcon />,primaryText: '待办事项'},
    {path: '/order-sd',icon: <DashboardIcon />,primaryText: '森动订单'},
    {path: '/order-jzhz',icon: <DashboardIcon />,primaryText: '建站盒子订单'},
    {path: '/order-domain',icon: <DashboardIcon />,primaryText: '域名订单'},
    {path: '/order-copy',icon: <DashboardIcon />,primaryText: '仿站订单'},
    {path: '/order-my',icon: <DashboardIcon />,primaryText: '模板建站订单'},
    {path: '/order-renew',icon: <DashboardIcon />,primaryText: '续费订单'},
    {path: '/site-template',icon: <DashboardIcon />,primaryText: '模板中心'},
    {path: '/photo-gallery',icon: <DashboardIcon />,primaryText: '图片集'},
    {path: '/baojiadan',icon:<DesktopWindows /> ,primaryText: '报价单'},
    {path: '/invoice',icon: <DashboardIcon />,primaryText: '发票管理'}, 
    {path: '/question-answer',icon: <DashboardIcon />,primaryText: '问答库'},
    {path: '/blacklist',icon: <DashboardIcon />,primaryText: '黑名单'}, 
    {path: '/userManagement',icon:<SupervisorAccount />,primaryText: '用户管理'},
    {path: '/modules',icon:<DashboardIcon />,primaryText: '模块管理'},
    {path: '/permission',icon:<DnsIcon />,primaryText: '权限设置'},
    {path: '/notice',icon:<AlarmIcon />,primaryText: '公告管理'},
    {path: '/news',icon:<TextsmsIcon />,primaryText: '消息管理'},
    {path: '/globalSet',icon:<DesktopWindows /> ,primaryText: '全局设置'},
// add new menu
]

class Index extends React.Component {
    constructor(props) {
        super(props);
        const historyMenu = _.find(menus, (item)=>item.path === props.historyPathname)
        this.state = {
            open: true,
            anchor: 'left',
            anchorEl: null,
            title: historyMenu ? historyMenu.primaryText : '个人面板',
            noticeOpen: false,
            expanded: 0,
        };
    }
    componentDidMount() {
        const {dispatch, user: {user}} = this.props
        dispatch(getAllSetting())
            .then((setting) => {
                console.info(setting, user);
                function setIp(name) {
                    dispatch(modifySetting(`${name}ip`, returnCitySN.cip));
                    localStorage.setItem(`${name}ip`, returnCitySN.cip);
                }

                if (user.name === 'ipcheck') {
                    if (location.hostname === 'zhigui.sungdell.com') {
                        setIp('纸圭');
                        localStorage.setItem(`双德ip`, setting[`双德ip`]);
                    } else {
                        setIp('双德');
                        localStorage.setItem(`纸圭ip`, setting[`纸圭ip`]);
                    }
                    setTimeout(function() {
                        location.reload();
                    }, 5 * 60 * 1000)
                } else {
                    localStorage.setItem(`双德ip`, setting[`双德ip`]);
                    localStorage.setItem(`纸圭ip`, setting[`纸圭ip`]);
                }
                
            });
        dispatch(getUnReadTotal());
    }
    handleDrawerChange = () => {
        this.setState({ open: !this.state.open });
    };
    handleDialogOpen = () => {
        this.setState({noticeOpen: true})
    }
    handleDialogClose = () => {
        this.setState({noticeOpen: false})
    }
    handleMenuOpen = (event) => {
        this.setState({anchorEl:event.currentTarget})
    }
    handleListClick = (menu) => {
        menu.key = !menu.key
    };
    handleMenuClose = () => {
        this.setState({anchorEl: null})
    }
    handleChange = index => (event, expanded) => {
        this.setState({
          expanded: expanded ? index : false,
        });
    };
    logout = () => {
        this.props.dispatch(signOutFn())
    }
    loadNoticeData = () => {
        const {dispatch} = this.props
        dispatch(getList())
    }
    changeTitle(menu) {
        const {allSetting} = this.props
        this.setState({title: menu.primaryText});
        document.title = `${allSetting['项目title']}-` + menu.primaryText;
    }
    getCurMenu = () => {
        const {classes,user:{user:{roles}}} = this.props
        const curTempMenu =  _.flattenDeep(roles.map((item,index) => { return item }).map((i,index) => {return i.rolePermissions})).map((item) => {return item})
        const allMenu =  menus.map((item,index) => {return item})
        const curMenu = allMenu.filter(item => curTempMenu.some(i => i.permissionName.includes(item.primaryText)))
        return curMenu.map((menu,index) => {
            return (
                <NavLink to={menu.path} activeStyle={menuActive} className={classes.navStyle} key={index} onClick={()=>this.changeTitle(menu)}>
                    <ListItem button>
                        <ListItemIcon className={classes.listItemIcon}>{menu.icon}</ListItemIcon>
                        <ListItemText inset primary={menu.primaryText} className={classes.listItemText} />
                        {menu.child && <IconButton style={{marginRight: -20,width:30,height:30}}  onClick={() => this.handleListClick(menu)}>{this.state.listOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}</IconButton>}
                    </ListItem>
                    {menu.child && <Collapse in={menu.key} timeout="auto" unmountOnExit>
                        {menu.child.map((childMenu,index) => {
                            return <List component="div" disablePadding key={index}>
                                <NavLink to={childMenu.path} className={classes.navStyle} activeStyle={menuActive}>
                                    <ListItem button className={classes.nested}>
                                        <ListItemIcon>
                                            {childMenu.icon}
                                        </ListItemIcon>
                                        <ListItemText inset primary={childMenu.primaryText} />
                                    </ListItem>
                                </NavLink>     
                            </List>
                        })}
                    </Collapse>}
                </NavLink>
            )
        })
    }
    render() {
        const { classes,user,noRead,allSetting,noticeData } = this.props;
        const { anchor,open,anchorEl, title,expanded } = this.state;
        const openMenu = Boolean(anchorEl)
        const drawer = (
            <Drawer
                variant="permanent"
                anchor={anchor}
                open={open}
                classes={{
                    paper: classNames(classes.drawerPaper, !open && classes.drawerPaperClose),
                }}
            >
                <div className={classes.toolbar}>
                    {allSetting['项目logo'] && <img src={`${allSetting['项目logo']}`} alt="项目logo" />}
                </div>
                <Divider />
                <List>
                    {this.getCurMenu()}
                </List>
            </Drawer>
        )
        return(
            <div className={classes.root}>
                <AppBar
                    position="absolute"
                    className={classNames(classes.appBar, open && classes.appBarShift)}
                    style={{background: "linear-gradient(to right, #F96487 , #1627b7)"}}
                >
                    <Toolbar disableGutters={!open} className={classes.toolPadding}>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={this.handleDrawerChange}
                        className={classNames(classes.menuButton)}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="title" color="inherit" noWrap className={classes.flex}>
                        {title}
                    </Typography>
                    {user.token && (
                        <div>
                            <IconButton className={classes.noticeButton} onClick={this.handleDialogOpen}>公告</IconButton>
                            {noRead > 0 ? <Badge className={classes.margin} badgeContent={noRead} color="secondary" onClick={() => this.context.router.history.push(`/news`)}>
                                <TextsmsIcon />
                            </Badge> :
                            <IconButton color="inherit" onClick={() => this.context.router.history.push(`/news`)}>
                                <TextsmsIcon />
                            </IconButton>}
                            <IconButton
                                aria-owns={open ? 'menu-appbar' : null}
                                aria-haspopup='true'
                                onClick={this.handleMenuOpen}
                                color="inherit"
                            >
                                <AccountCircle />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                open={openMenu}
                                onClose={this.handleMenuClose}
                            >
                                <MenuItem onClick={this.logout}>注销</MenuItem>
                            </Menu>
                        </div>
                    )}
                    </Toolbar>
                </AppBar>
                {drawer}
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    <div>
                        {user.token &&
                        <div>
                            <Switch>
                                <Route path="/icenter" component={Icenter} /> 
                                <Route path="/order-sd" component={Ordersd} />
                                <Route path="/order-domain" component={OrderDomain} />
                                <Route path="/order-jzhz" component={OrderJzhz} />
                                <Route path="/order-copy" component={OrderCopy} />
                                <Route path="/order-my" component={OrderMy} />
                                <Route path="/order-renew" component={OrderRenew} /> 
                                <Route path="/site-template" component={SiteTemplate} />
                                <Route path="/baojiadan" component={Baojiadan} /> 
                                <Route path="/invoice" component={Invoice} />
                                <Route path="/userManagement" component={User} />
                                <Route path="/modules" component={Modules} />
                                <Route path="/permission" component={Permission} />
                                <Route path="/globalSet" component={GlobalSet} />
                                <Route path="/notice" component={Notice} />
                                <Route path="/news" component={News} />
                                <Route path="/question-answer" component={QuestionAnswer} />
                                <Route path="/todo-task" component={TodoTask} />
                                <Route path="/blacklist" component={Blacklist} /> 
                                <Route path="/photo-gallery" component={Photogallery} /> 
{/* add new Route */}
                                <Redirect to={{pathname: '/icenter'}} />
                            </Switch>
                        </div>}                  
                    </div>
                    <QQ value={`${allSetting['客服QQ']}`} />
                    <Feedback />
                    <UpdateDes />
                    <Message />
                </main>
                <Dialog 
                    open={this.state.noticeOpen && noticeData.length> 0} 
                    fullWidth 
                    onClose={this.handleDialogClose} 
                    onEntering={this.loadNoticeData}
                >
                    {_.slice(noticeData,0,5).map((item,index) => {
                        return   <ExpansionPanel key={index} expanded={expanded === index} onChange={this.handleChange(index)}>
                                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                        <div className={classes.expandTitle}>
                                            <Typography className={classes.heading}><CloudDoneIcon color="primary" className={classes.titleIcon} />{item.title}</Typography>
                                            <Typography variant="caption">{DateFormat(new Date(item.createTime),'yyyy-MM-dd')}</Typography>
                                        </div>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                        <Typography component="div" className={classes.contentContainer}>
                                            {item.content.split('\n').map((ii,index)=>{
                                                return (<div key={index}><span className={classes.listIcon}>&#9670;</span>{ii}</div>)
                                            })}
                                        </Typography>
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                    })}
                </Dialog>
        </div>
        )
    }
}

Index.contextTypes = {
    router: PropTypes.object.isRequired
};
Index.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
}
const mapStateToProps = ({auth, router,news,global,notice}) => {
    return {
        user:auth.user,
        historyPathname: router.location.pathname,
        noRead: news.unRead,
        allSetting: global.allSetting,
        noticeData: notice.list
    }
}

export default connect(mapStateToProps)(withStyles(styles,{withTheme:true}) (Index))


// WEBPACK FOOTER //
// ./src/pages/home/components/app.js